import { styledWithTheme } from "../../context";
var DropdownUl = styledWithTheme('ul')(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    listStyleType: 'none',
    padding: '0',
    margin: '0',
    overflowY: 'auto',
    backgroundColor: selectors.color('neutral0'),
    ':focus': {
      outline: 'none'
    }
  };
});
DropdownUl.displayName = 'DropdownUl';
export default DropdownUl;